// Digismoothie Agency Customisations

// Toggle dealer countries modal
const toggleDealerCountriesModal = () => {
  document.querySelector('.dealer-countries-modal').classList.toggle('is-open');
  document.documentElement.style.overflow = document.documentElement.style.overflow === 'hidden' ? '' : 'hidden';
}
// Wrap certain product info with DIV
$( ".product-block__info-group" ).wrapAll( "<div class='product-block__wrapper info-group' />");
$( ".product-block__price-group" ).wrapAll( "<div class='product-block__wrapper price-group' />");
// Remove extra parent node from table
const tableWrapper = document.querySelector('.table-wrapper');
if (tableWrapper !== null) {
  const originalTable = tableWrapper.querySelectorAll('table');
  if (originalTable.length > 1) {
    const newTable = originalTable[originalTable.length - 1];
    tableWrapper.innerHTML = newTable.outerHTML;
  }
}
